import Cookies from "js-cookie";

/** Mirrors login cookie attrs so API headers stay consistent across refresh. */
function officeCodeCookieAttrs() {
  return {
    domain: process.env.REACT_APP_COOKIE_DOMAIN,
    expires: 30,
    secure: process.env.REACT_APP_COOKIE_SECURE === "true",
    sameSite: "Lax",
  };
}

export function getActiveOfficeCodeFromStorage() {
  return (
    (typeof window !== "undefined" &&
      (localStorage.getItem("officeCode") || Cookies.get("officeCode"))) ||
    ""
  ).trim();
}

export function getAssignedOfficeCodesFromStorage() {
  const raw =
    (typeof window !== "undefined" && Cookies.get("officeCodes")) || "";
  const list = String(raw)
    .split(",")
    .map((c) => c.trim())
    .filter(Boolean);
  if (list.length) return list.join(",");
  return getActiveOfficeCodeFromStorage();
}

export function getOrganizationDataFromStorage() {
  if (typeof window === "undefined") return [];
  try {
    const stored = JSON.parse(localStorage.getItem("organizationData"));
    return Array.isArray(stored) ? stored : [];
  } catch {
    return [];
  }
}

function normalizeAssignableOrganization(org) {
  if (!org || typeof org !== "object") return null;
  const officeCode = String(org.officeCode ?? "").trim();
  if (!officeCode) return null;
  return {
    officeCode,
    organizationName:
      org.organizationName ??
      org.officeName ??
      org.name ??
      org.orgName ??
      officeCode,
  };
}

/** Profile API + login storage + officeCodes cookie — deduped by office code. */
export function resolveAssignableOrganizations(profileOrganizations = []) {
  const byCode = new Map();
  const add = (org) => {
    const normalized = normalizeAssignableOrganization(org);
    if (normalized) byCode.set(normalized.officeCode, normalized);
  };

  (Array.isArray(profileOrganizations) ? profileOrganizations : []).forEach(add);
  getOrganizationDataFromStorage().forEach(add);

  getAssignedOfficeCodesFromStorage()
    .split(",")
    .map((c) => c.trim())
    .filter(Boolean)
    .forEach((code) => {
      if (!byCode.has(code)) {
        byCode.set(code, { officeCode: code, organizationName: code });
      }
    });

  return Array.from(byCode.values());
}

export function persistActiveOfficeCode(officeCode) {
  const code = String(officeCode ?? "").trim();
  if (!code) return;
  if (typeof window === "undefined") return;
  localStorage.setItem("officeCode", code);
  Cookies.set("officeCode", code, officeCodeCookieAttrs());
}
